//user
export const USER_LOGIN = "USER_LOGIN";
export const USER_GET = "USER_GET";
export const USER_UPDATE_MY_PROFILE = "USER_UPDATE_MY_PROFILE";

//event
export const EVENT_GET_LIST = "EVENT_GET_LIST";